/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getCorporategrpList: (params) => {
    return axios.get(API_ENDPOINTS.GET_CORPORATE_GRP, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getCorporateEmpList: (params) => {
  return axios.get(API_ENDPOINTS.GET_CORPORATE_EMPLOYEES, {
  headers: { isAuthRequired: true, "Content-Type": "application/json" },
  params,
  });
  },
  getCorpEmpDetails: (id) => {
    return axios.get(API_ENDPOINTS.GET_CORPORATE_EMPLOYEES_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addCorporateEmployee: (data) => {
    return axios.post(API_ENDPOINTS.ADD_EMPLOYEES, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  updateCorporateEmp: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_CORPORATE_EMPLOYEES_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data", },
    });
  },
  deleteCorpemp: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_CORPORATE_EMPLOYEES_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
};
